(function () {
  function initGallery(root) {
    if (!root || root.dataset.dsGenericGalleryReady === 'true') return;

    const rail = root.querySelector('[data-ds-generic-gallery-rail]');
    const previousButton = root.querySelector('[data-ds-generic-gallery-prev]');
    const nextButton = root.querySelector('[data-ds-generic-gallery-next]');
    if (!rail) return;

    root.dataset.dsGenericGalleryReady = 'true';

    const getStep = function () {
      const firstItem = rail.querySelector('[data-ds-generic-gallery-item]');
      if (!firstItem) return Math.max(rail.clientWidth * 0.88, 1);
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return firstItem.getBoundingClientRect().width + gap;
    };

    const updateButtons = function () {
      const maxScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
      if (previousButton) previousButton.disabled = rail.scrollLeft <= 2;
      if (nextButton) nextButton.disabled = rail.scrollLeft >= maxScroll - 2;
    };

    previousButton?.addEventListener('click', function () {
      rail.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextButton?.addEventListener('click', function () {
      rail.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    let updateFrame = 0;
    rail.addEventListener(
      'scroll',
      function () {
        window.cancelAnimationFrame(updateFrame);
        updateFrame = window.requestAnimationFrame(updateButtons);
      },
      { passive: true }
    );
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  function init(scope) {
    if (scope.matches?.('[data-ds-generic-gallery]')) initGallery(scope);
    scope.querySelectorAll?.('[data-ds-generic-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
